import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { InterestStatus } from '../../types/candidateInterest';

import { LazyListRequest, LazyListResponse } from '../../types/types';
import { AppDispatch, RootState } from '../store';
import { buildReducers, createRequestStatusObject, RequestStatusObject } from '../utils';
import { DailyUpdates } from '../../types/daily-updates';

export interface DailyUpdatesState {
	dailyUpdates: DailyUpdates | null;

	listOrganisationDailyUpdatesRequest: RequestStatusObject;
}

const initialState: DailyUpdatesState = {
	dailyUpdates: null,

	listOrganisationDailyUpdatesRequest: createRequestStatusObject()
};

export const listOrganisationDailyUpdates = createAsyncThunk<
	{ data: LazyListResponse<DailyUpdates>; roleName: string },
	{
		organisationId: string;
		roleName: string;
		status: InterestStatus | null;
		advertId?: string;
		lastLoggedOut?: string;
		dailyUpdates?: boolean;
	} & LazyListRequest,
	{ dispatch: AppDispatch; state: RootState }
>(
	'dailyUpdates/listOrganisationDailyUpdates',

	async ({ organisationId, limit, next, roleName, status, advertId, lastLoggedOut, dailyUpdates = false }) => {
		// current user Id
		const result = await API.get('inspirusapi', `/organisations/${organisationId}/daily-updates`, {
			headers: {},
			response: true,
			queryStringParameters: {
				limit,
				next,
				roleName,
				status,
				spotlightId: advertId,
				lastLoggedOut,
				dailyUpdates
			}
		});

		return { data: result.data, roleName };
	}
);

const dailyUpdatesSlice = createSlice({
	name: 'dailyUpdates',
	initialState,
	reducers: {
		resetDailyUpdates: (state) => {
			state = initialState;
			return state;
		}
	},
	extraReducers: (builder) => {
		buildReducers(builder, listOrganisationDailyUpdates, 'listOrganisationDailyUpdatesRequest', {
			onFulfilled: (state, payload) => {
				state.dailyUpdates = {
					...state.dailyUpdates,
					[payload.roleName]: payload.data
				};
			}
		});
	}
});

export const { resetDailyUpdates } = dailyUpdatesSlice.actions;
export default dailyUpdatesSlice.reducer;
